import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RequireAuth({ allowedRoles, children }) {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth?mode=login" state={{ from: location }} replace />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    // If logged in but wrong role, send to the correct home page
    const redirect =
      role === 'admin'
        ? '/admin/dashboard'
        : role === 'tasker'
        ? '/tasker/dashboard'
        : '/customer/home';
    return <Navigate to={redirect} replace />;
  }

  return children;
}
